import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { Table, TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { SelectModule } from 'primeng/select';
import { ServerTranslatePipe } from '@app/utils/pipes/server-translate-pipe';
import { ListPageWrapper } from '@app/wrappers/pages/list-page-wrapper/list-page-wrapper';
import { GenericSelectorComponent } from '../../../Ui-Kit/generic-selector/generic-selector.component';
import { GenericSelectorConfig } from '../../../Ui-Kit/generic-selector/generic-selector.models';
import { SelectItem } from 'primeng/api';
import { LocalizedDropdownComponent } from '../../../Ui-Kit/localized-dropdown/localized-dropdown.component';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ButtonModule,
    TableModule,
    TooltipModule,
    SelectModule,
    ServerTranslatePipe,
    ListPageWrapper,
    GenericSelectorComponent,
    LocalizedDropdownComponent,
  ],
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
})
export class UserListComponent {
  @Input() users: any[] = [];
  @Input() rolesData: any[] = [];
  @Input() totalRecords: number = 0;
  @Input() loading: boolean = false;
  @Input() isSmallScreen: boolean = false;
  @Input() pageSize: number = 10;
  @Input() filters: any = {};
  @Input() userSelectorConfig!: GenericSelectorConfig<any>;
  @Input() orgSelectorConfig!: GenericSelectorConfig<any>;
  @Input() roleSelectorConfig!: GenericSelectorConfig<any>;
  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() filtersChange = new EventEmitter<any>();
  @Output() onEditUser = new EventEmitter<any>();
  @Output() onApplyFilters = new EventEmitter<void>();
  @Output() onClearFilters = new EventEmitter<void>();
  @Output() onAddIndividual = new EventEmitter<void>();
  @Output() onAddLegal = new EventEmitter<void>();
  @Output() onImportIndividual = new EventEmitter<void>();
  @Output() onImportLegal = new EventEmitter<void>();

  @ViewChild('userTable') userTable!: Table;

  showAddDropdown: boolean = false;

  pageSizeOptions = [
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
  ];

  userTypeOptions: SelectItem[] = [
    { label: 'All Types', value: null },
    { label: 'Individual', value: 1 },
    { label: 'Legal Entity', value: 0 },
  ];

  statusOptions: SelectItem[] = [
    { label: 'All Statuses', value: null },
    { label: 'Blocked', value: true },
    { label: 'Active', value: false },
  ];

  onFilterChange(field: string, value: any): void {
    if (value !== null && value !== undefined && value !== '') {
      this.filters = { ...this.filters, [field]: value };
    } else {
      const newFilters = { ...this.filters };
      delete newFilters[field];
      this.filters = newFilters;
    }
    this.filtersChange.emit(this.filters);
  }

  toggleAddDropdown(): void {
    this.showAddDropdown = !this.showAddDropdown;
  }

  getRoles(roles: string[]): any[] {
    if (!roles || !this.rolesData) return [];
    const upperRoles = roles.map((r) => r.toUpperCase());
    return this.rolesData.filter((role) => role.normalizedName && upperRoles.includes(role.normalizedName));
  }

  handlePageSizeChange(event: any): void {
    this.pageSizeChange.emit(event.value);
  }

  applyFilters(): void {
    if (this.userTable) {
      this.userTable.reset();
    }
    this.onApplyFilters.emit();
  }

  clearFilters(): void {
    if (this.userTable) {
      this.userTable.reset();
    }
    this.filters = {};
    this.filtersChange.emit(this.filters);
    this.onClearFilters.emit();
  }

  resetTable(): void {
    if (this.userTable) {
      this.userTable.reset();
    }
  }
}
